import templateUrl from './ingredient-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    companyId: '<',
    ingredient: '<',
    ingredients: '<',
    submitTitle: '@',
    unitsDisplay: '<',
    weightUnits: '<',
    ingredientChanged: '&',
    index: '<',
    showAdditionalButton: '<',
    disallowActiveIngredients: '<'
  },
  controller: class IngredientFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      if (this.ingredient) {
        this.selectedIngredient = this.ingredient;
      } else if (this.disallowActiveIngredients) {
        this.ingredient = {
          Active: false
        };
      }

      this.ingredients = this.ingredients || [];
    }

    ingredientTypeChanged(isActive) {
      this.validateDuplicates();

      if (!isActive) {
        this.ingredient = {
          ...this.ingredient,
          Weight: null,
          WeightUnit: null
        };
      }
    }

    onSubmit(shouldClose) {
      const ingredient = {
        ...this.selectedIngredient,
        ...this.ingredient
      };

      this.ingredients.push(ingredient);

      this.ingredientChanged(
        this.EventEmitter({
          ingredient,
          shouldClose,
          index: this.index
        })
      );

      this.ingredient = {};

      this.selectedIngredient = null;
      this.ingredientSearchText = '';
    }

    selectedSearchIngredientChanged($event) {
      this.selectedIngredient = $event.selectedIngredient;
      if (this.disallowActiveIngredients) {
        this.ingredient = {
          ...this.selectedIngredient,
          Active: false
        };
      }
      this.validateDuplicates();
    }

    validateDuplicates() {
      let isValid = true;

      if (this.selectedIngredient) {
        // Business rule - ensure no duplicates
        const index = this.ingredients.findIndex(i =>
          i.UserIngredientId === this.selectedIngredient.UserIngredientId
        );

        if (index !== -1 && this.index !== index) {
          isValid = false;
        }
      }

      this.ingredientForm.$setValidity('duplicate', isValid);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/ingredient-form/ingredient-form.component.js